import { SpecialSymbolGroup } from './special-symbol-group.model';
import { Line } from './line.model';
import { SpinResponse } from './machine-state.model';
import { ReelWinPosition } from './reel-position.model';
import { ReelState } from './reel-state.model';
import { InternalBet } from './internal-bet.model';

/**
 * @deprecated Use FreeSpinsIfo class for reSpins
 */
export class InternalRespinSpecGroup {
  respinStarted = false;
  respinCounter = 0;
  respinStartedCounter = 0;
  get currentRound(): InternalRespinRound {
    return this.groups[this.respinCounter];
  }
  groups: InternalRespinRound[];
  firstWin: number;
}

/**
 * @deprecated Use FreeSpinsInfo class for reSpins
 */
export class InternalRespinRound {
  newViewReels: number[][];
  fixedPositions: number[];
  winLines: Line[];
  winPositions: ReelWinPosition[];
  type: string;
  multiplier: number;
  roundWin: number;
  winName: string;
  specialSymbolGroups: SpecialSymbolGroup[] | null;
}

export class InternalJackpotsSpecGroup {
  jackPotValues: number[];
  jackPotInitialValues: number[];
}

export class SlotMachineInfo {
  bets: InternalBet[];
  cheatUser: boolean;
  defaultBet: number;
  betMultiplier: number;
  maxLines: number;
  symbols: MachineSymbol[];
  machineState: SpinResponse | null;
  lines: number[];
  configs: string[];
  cheatCommands: string[];
  cheatReels: boolean;
  customCheatInput: boolean;
  balance: number | null = null;
}

// export class SlotMachineModuleInfo {
//   maxLines: number;
//   symbols: MachineSymbol[];
//   machineState: SpinResponse;
//   lines: number[];
// }
// export class ModularSlotMachineInfo extends SlotMachineInfo implements IModularSlotMachineInfo {
//   modularSpinResult: IModularSpinResponse;
//   modulesInfo: Record<string, SlotMachineModuleInfo>;
// }

export class ModularSpinResponse extends SpinResponse {
  public moduleReelStates: Record<string, ReelState>;
  public totalWinWithModules: number;
  public totalLostWithModules: number;

  public clearWinLines(): void {
    super.clearWinLines();
    Object.values(this.moduleReelStates).forEach((reelState) => {
      if (reelState?.winLines) {
        reelState.winLines.length = 0;
      }
    });
  }

  public clearWinPositions(): void {
    super.clearWinPositions();
    Object.values(this.moduleReelStates).forEach((reelState) => {
      if (reelState?.winPositions) {
        reelState.winPositions.length = 0;
      }
    });
  }
}

export class MachineSymbol {
  gains: number[] | null;
  typeGains: number[] | null;
  id: number;
  stacked: number;
  type: string;
}

export enum SpecialSymbolGroupType {
  FreeSpinType = 'FreeSpinType',
  Hook = 'Hook',
  Dynamite = 'Dynamite',
  Bazooka = 'Bazooka',
  Collector = 'Collector',
  CollectSymbol = 'CollectSymbol',
  Progress = 'Progress',
  BigWinTotalWin = 'BigWinTotalWin',
  MoreCollectSymbol = 'MoreCollectSymbol',
  MoreCollector = 'MoreCollector',
  MoreDynamitesHooksAndBazookas = 'MoreDynamitesHooksAndBazookas',
  StartFromLevel2 = 'StartFromLevel2',
  AdditionalSpins = 'AdditionalSpins',
  ReplaceSymbol = 'ReplaceSymbol',
  Multiplier = 'Multiplier',
  StickyWilds = 'StickyWilds',
  Milestone = 'Milestone',
}
